import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SydButton from '../../../../commonDesign/Button'
import ColumnConfigEditor from '../../../../pages/denali/Analysis/QueryBlueprints/components/presentationManagement/typeEditors/ColumnConfigEditor'
import generateLocalStorageKey from '../../../../pages/denali/Analysis/QueryBlueprints/components/presentationManagement/generateLocalStorageKey'
import { ALL_AVAILABLE_COLUMNS, buildDefaultColumns, deriveIncludes } from './columnDefs'

export default function ColumnsSection ({ configPrefix, control, setValue }) {
  return (
    <Controller
      name={`${configPrefix}.columns`}
      control={control}
      render={({ field }) => {
        const columns = field.value ?? buildDefaultColumns()

        const updateColumns = (next) => {
          field.onChange(next)
          setValue(`${configPrefix}.includes`, deriveIncludes(next))
        }

        const handleAddColumn = (col) => {
          updateColumns([...columns, col])
        }

        const handleRemoveColumn = (index) => {
          const next = [...columns]
          next.splice(index, 1)
          updateColumns(next)
        }

        const handleUpdateColumn = (index, updated) => {
          const next = [...columns]
          next[index] = updated
          updateColumns(next)
        }

        const handleColumnsChange = (next) => {
          updateColumns(next)
        }

        const handleResetToDefault = () => {
          updateColumns(buildDefaultColumns())
        }

        return (
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
              <SydButton variant='ghost' size='xs' onClick={handleResetToDefault}>
                Reset to Default
              </SydButton>
            </div>
            <ColumnConfigEditor
              columns={columns}
              availableColumns={ALL_AVAILABLE_COLUMNS}
              onAddColumn={handleAddColumn}
              onRemoveColumn={handleRemoveColumn}
              onUpdateColumn={handleUpdateColumn}
              onColumnsChange={handleColumnsChange}
            />
          </div>
        )
      }}
    />
  )
}

ColumnsSection.propTypes = {
  configPrefix: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired
}

export function LocalStorageKeyField ({ configPrefix, control }) {
  return (
    <Controller
      name={`${configPrefix}.localStorageKey`}
      control={control}
      render={({ field }) => (
        <SydLabel label='Local Storage Key' helperText='Unique key for persisting user column preferences'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <SydInput
              value={field.value || ''}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder='e.g. synced-txns.my-view'
            />
            <SydButton
              size='sm'
              variant='outline'
              onClick={() => field.onChange(generateLocalStorageKey())}
              disabled={!!field.value}
            >
              Auto
            </SydButton>
            {field.value
              ? (
                <SydButton
                  size='sm'
                  variant='ghost'
                  onClick={() => field.onChange('')}
                >
                  Clear
                </SydButton>
              )
              : null}
          </div>
        </SydLabel>
      )}
    />
  )
}

LocalStorageKeyField.propTypes = {
  configPrefix: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired
}
